import React, { useRef, useCallback } from "react";

const toDisplay = (isoDate) => {
  if (!isoDate) return "";
  const parts = isoDate.split("-");
  if (parts.length !== 3) return isoDate;
  return `${parts[1]}-${parts[2]}-${parts[0]}`;
};

const DatePickerInput = ({
  value,
  onChange,
  className = "",
  placeholder = "MM-DD-YYYY",
  min,
  max,
}) => {
  const dateRef = useRef(null);

  const openPicker = useCallback(() => {
    const el = dateRef.current;
    if (!el) return;
    if (typeof el.showPicker === "function") {
      el.showPicker();
    } else {
      el.click();
    }
  }, []);

  return (
    <div className="relative cursor-pointer" onClick={openPicker}>
      <div className={`${className} flex items-center justify-between`}>
        <span className={value ? "text-gray-900" : "text-gray-400"}>
          {value ? toDisplay(value) : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <input
        ref={dateRef}
        type="date"
        value={value || ""}
        onChange={onChange}
        min={min}
        max={max}
        style={{ position: "absolute", top: 0, left: 0, width: "1px", height: "1px", opacity: 0, pointerEvents: "none" }}
      />
    </div>
  );
};

export default DatePickerInput;
